import { render, staticRenderFns } from "./BaseBTable.vue?vue&type=template&id=50ad9edc&scoped=true"
import script from "./BaseBTable.vue?vue&type=script&lang=js"
export * from "./BaseBTable.vue?vue&type=script&lang=js"
import style0 from "./BaseBTable.vue?vue&type=style&index=0&id=50ad9edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ad9edc",
  null
  
)

export default component.exports